import { Organisation } from '~organisations/domain';

import logo from './images/logo.svg';

const belongConfig: Organisation = {
  logo: logo,
  additionalOutcomeCaptureFields: {},
  asyncAdditionalOutcomeCaptureFields: {},
  contactAssessmentForms: {},
};

export default belongConfig;
